import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, HideScrollbar, LineClamp } from '../../../global/commonStyle';
import { Typography } from '../../../global/theme';

interface Props {
  isProjectDetail?: boolean;
  isKeyboardVisible?: boolean;
  isApplyManualHeight?: boolean;
  isApplyMargin?: string;
  simpleContent?: boolean;
  isBubbleMenuOpen?: boolean;
}
const MessageInputSection = styled.div<Props>`
  ${AlignCenter}
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-8);
  padding: var(--space-8) var(--space-8) var(--space-8) var(--space-12);
  min-height: 30px;
  box-shadow: var(--shadow-card);
  position: relative;
  transition: width var(--transition-normal) cubic-bezier(0.4, 0, 0.2, 1);
  ${mobile_xl(css<Props>`
    /* Use CSS custom properties for width calculations */
    --input-width: ${({ isKeyboardVisible, isProjectDetail }) =>
      isKeyboardVisible ? 'calc(100vw - 48px)' : isProjectDetail ? 'calc(100vw - 124px)' : 'calc(100vw - 192px)'};
    --input-border-radius: ${({ isKeyboardVisible }) =>
      isKeyboardVisible ? 'var(--border-radius-16)' : 'var(--border-radius-full)'};
    --is-bubble-menu: ${({ isBubbleMenuOpen }) => (isBubbleMenuOpen ? 'none' : 'blur(14px)')};
    width: var(--input-width);
    border: unset;
    border-radius: var(--input-border-radius);
    overflow: hidden;
    padding: var(--space-4);
    position: relative;
    background: var(--glass-base-tint-2);
    box-shadow: var(--glass-drop-shadow-2);
    flex-direction: column;
    align-items: flex-start;
    backdrop-filter: var(--is-bubble-menu);
    ${(props) =>
      props.isProjectDetail &&
      css`
        margin: var(--space-0);
      `}
  `)}
`;
const IconSection = styled.div`
  display: flex;
  gap: var(--space-4);
  position: absolute;
  right: 8px;
  bottom: 8px;
  .active {
    svg {
      fill: var(--text-primary);
    }
  }
  ${mobile_xl(css`
    width: 100%;
    position: unset;
    justify-content: space-between;
  `)}
`;
const IconLeftSection = styled.div`
  display: flex;
  gap: var(--space-4);
  ${mobile_xl(css`
    gap: var(--space-0);
  `)}
`;

const Icon = styled.div<{ disable?: boolean }>`
  display: flex;
  position: relative;
  .fillColor {
    fill: var(--text-secondary);
    cursor: pointer;
    &:hover {
      fill: var(--text-primary);
    }
  }
  .attachment-fill-Color {
    fill: var(--text-secondary);
    cursor: pointer;
    &:hover {
      fill: var(--text-primary);
    }
  }
  ${(props) =>
    props.disable &&
    css`
      pointer-events: none;
    `}
`;
const TextBox = styled.div<Props>`
  width: calc(100% - 104px);
  .tiptap {
    max-height: 240px;
    ${HideScrollbar}
    transition: max-height var(--transition-normal) cubic-bezier(0.4, 0, 0.2, 1);
    ${({ isApplyManualHeight }) =>
      isApplyManualHeight &&
      css`
        min-height: 100px;
      `}
  }
  ${mobile_xl(css<Props>`
    /* Use CSS custom properties for dynamic values */
    --keyboard-max-height: ${({ isKeyboardVisible }) => (isKeyboardVisible ? '82px' : '22px')};
    --keyboard-padding-right: ${({ isKeyboardVisible }) => (isKeyboardVisible ? 'var(--space-12)' : 'var(--space-0)')};
    --keyboard-flex-direction: ${({ isKeyboardVisible }) => (isKeyboardVisible ? 'column' : 'row')};
    --keyboard-align-items: ${({ isKeyboardVisible }) => (isKeyboardVisible ? 'flex-start' : 'center')};
    .tiptap {
      max-height: var(--keyboard-max-height);
      padding: var(--space-13) var(--keyboard-padding-right);
      transition: max-height var(--transition-normal) cubic-bezier(0.4, 0, 0.2, 1),
        padding var(--transition-normal) cubic-bezier(0.4, 0, 0.2, 1);
      ${({ simpleContent }) =>
        simpleContent &&
        css`
          p {
            ${LineClamp(1)}
            text-overflow: ellipsis;
            word-break: break-all;
          }
        `}
    }
    width: 100%;
    display: flex;
    flex-direction: var(--keyboard-flex-direction);
    align-items: var(--keyboard-align-items);
    :nth-child(2) {
      width: 100%;
    }
  `)}
`;

const UploadDiv = styled.div`
  color: var(--text-primary);
`;

const FileBox = styled.div<Props>`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-10);
  margin-block: var(--space-12) ${(props) => props.isApplyMargin};
  padding: var(--space-0);
  ${mobile_xl(css`
    margin-block: var(--space-0);
  `)}
`;

const Emojis = styled.div<Props>`
  aside.EmojiPickerReact.epr-main {
    border: none;
  }
  .epr-body {
    margin-bottom: var(--space-1) !important;
  }
  .EmojiPickerReact {
    background-color: var(--background-primary);
  }
  .EmojiPickerReact .epr-category-nav > button.epr-cat-btn {
    background-image: url(https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/Template_images%2Femoji_svg_ref.svg?alt=media&token=7fd738ed-1e10-4c18-8f91-a0c4b6c7ef5f);
  }
  .epr_-z2fuzw {
    padding: var(--space-4) var(--space-8) !important;
    background-color: var(--background-primary) !important;
    border-radius: var(--border-radius-6) !important;
    border: 0.5px solid var(--border-primary) !important;
    color: var(--text-primary) !important;
    ${Typography.body_sm_medium}
    height: 25px !important;
  }
  .EmojiPickerReact li.epr-emoji-category > .epr-emoji-category-label {
    ${Typography.body_xs_semibold}
    height: auto !important;
    padding-block: var(--space-6) !important;
    color: var(--text-secondary) !important;
  }
  .EmojiPickerReact li.epr-emoji-category > .epr-emoji-category-label {
    background-color: var(--background-primary);
  }
  .EmojiPickerReact button.epr-emoji:hover > * {
    border-radius: var(--border-radius-6) !important;
    background-color: var(--neutral-secondary) !important;
  }

  .EmojiPickerReact .epr-search-container input.epr-search::placeholder {
    color: var(--text-placeholder) !important;
  }
  .EmojiPickerReact .epr-body::-webkit-scrollbar-thumb {
    background-color: var(--text-tertiary) !important;
    border-radius: var(--border-radius-6) !important;
    min-height: 20px !important;
  }
  .EmojiPickerReact .epr-search-container input.epr-search:focus {
    border: 0.5px solid var(--brand-primary) !important;
  }
  .epr_jkst5z:focus {
    border-radius: var(--border-radius-6) !important;
    background-color: var(--neutral-secondary) !important;
  }
  .epr_c90x4z {
    display: none;
  }
`;

export { MessageInputSection, IconSection, TextBox, UploadDiv, Icon, FileBox, Emojis, IconLeftSection };
